var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingingParty = function SvgSingingParty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.368 7.05a3.009 3.009 0 1 0 0-6.018 3.009 3.009 0 0 0 0 6.017zm1.792 5.275c.138.07.268.138.433.227.187.1.353.234.489.397a1.79 1.79 0 0 0 2.703.045 1.867 1.867 0 0 0-.119-2.514 5.2 5.2 0 0 0-1.388-1.075C16.88 7.59 14.84 8.7 13.469 9.76a1.53 1.53 0 0 1-1.749.086l-1.311-.824a1.79 1.79 0 0 0-2.583.88 1.86 1.86 0 0 0 .829 2.231l2.467 1.48a1.79 1.79 0 0 0 1.546.141l1.921-1.032v2.475a7.8 7.8 0 0 0-2.693 6 1.79 1.79 0 0 0 1.785 1.771h.024a1.764 1.764 0 0 0 1.759-1.794c-.041-2.58 1.903-3.492 2.3-3.997a3.3 3.3 0 0 1 1.754 1.937 1.79 1.79 0 0 0 1.694 1.219 1.78 1.78 0 0 0 1.667-2.426 6.8 6.8 0 0 0-1.27-2.203M4.713 7.407V1.083c1.417 0 2.653.708 2.653 2.122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.857 9.53a1.857 1.857 0 1 0 0-3.714 1.857 1.857 0 0 0 0 3.714"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M9.96 5.06a.366.366 0 0 1 0-.733m0 .733a.366.366 0 1 0 0-.733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.884 13.921v4.205m-2.102-2.103h4.205"
  })));
};
export default SvgSingingParty;